export default "__VITE_ASSET__BOFT8QyQ__"